export const CHANGE_PLAN_SELECT_NEW_PLAN=`CHANGE_PLAN_SELECT_NEW_PLAN`
export const CHANGE_PLAN_UPLOAD_PHOTOS_OF_CAR=`CHANGE_PLAN_UPLOAD_PHOTOS_OF_CAR`
export const CHANGE_PLAN_REVIEW_AND_CONFIRM_PAGE=`CHANGE_PLAN_REVIEW_AND_CONFIRM_PAGE`